module.exports = __webpack_public_path__ + "static/media/YM70_0.93b37f73.jpg";